import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	configureFieldButtonLabelNonFinal: {
		id: 'polaris-common.fields.connection.configure-field-button-label-non-final',
		defaultMessage: 'Configure field',
		description: 'Button label to open the right sidebar to configure the field',
	},
});
